import { useQuery } from '@tanstack/react-query'

import { useSession } from '@/contexts/SessionContext'
import { pickBatches } from '@/db/repositories/stock'

/** The batches a cart line will take stock from, as the sale will pick them (FEFO, then FIFO). Display only. */
export const useBatchPreview = (variationId: string, quantity: number) => {
  const { stage } = useSession()
  const { data = [] } = useQuery({
    queryKey: ['batch-preview', variationId, quantity],
    queryFn: () => pickBatches(variationId, quantity),
    enabled: stage !== 'demo',
  })
  return data.filter((p) => p.stock_purchase_transaction_id)
}

/** A short handle for a batch, which has no number of its own: the end of its stock-in transaction id. */
export const batchLabel = (id: string | null) => (id ? `#${id.slice(-4).toUpperCase()}` : '—')
